import { StatusProps } from 'utils/constants';
export interface ApiErrorResponse {
  status: number;
  data: {
    success: false;
    errors: { [key: string]: string[] };
  };
}

/**
 * Extracts a single, human-readable error message from an ApiErrorResponse.
 * Returns the first available error, or a fallback if none are found.
 */
export const getErrorMessage = (error: ApiErrorResponse, fallback = 'Something went wrong'): string => {
  const errors = error?.data?.errors;
  if (!errors) return fallback;

  for (const messages of Object.values(errors)) {
    if (messages?.length) return messages[0];
  }

  return fallback;
};

export const toLocaleString = (
  value: number | string | Date | null,
  style: Intl.DisplayNamesType,
  fallback: number | string | Date,
) => {
  switch (style) {
    case 'currency': {
      return Number(value || fallback).toLocaleString(undefined, { style, currency: 'AUD' });
    }
    default:
      return '';
  }
};

export const getStatusName = (statusMap: Record<string, StatusProps>, value: string): string =>
  Object.values(statusMap).find((status) => status.value === value)?.name ?? value;
